import { useEffect, useState } from 'react';

import countries from '@/shared/configs/countries.json';
import Customer from '@/shared/types/customer.type';

const areAddressesEqual = (customer: Customer) => {
  return (
    customer.delivery_address === customer.billing_address &&
    customer.delivery_address2 === customer.billing_address2 &&
    customer.delivery_city === customer.billing_city &&
    customer.delivery_country === customer.billing_country &&
    customer.delivery_state === customer.billing_state &&
    customer.delivery_postcode === customer.billing_postcode
  );
};

type Args = {
  customer: Customer | null;
};

const useDeliveryAddressForm = ({ customer }: Args) => {
  const [deliveryAddressFormFields, setDeliveryAddressFormFields] = useState<
    Partial<Customer> & { billing_same_as_delivery: boolean }
  >({
    delivery_address: '',
    delivery_address2: '',
    delivery_city: '',
    delivery_country: '',
    delivery_state: '',
    delivery_postcode: '',
    billing_same_as_delivery: false,
  });

  const onUpdateDeliveryAddress = (values: Record<string, unknown>) => {
    setDeliveryAddressFormFields((prev) => {
      if (values.delivery_country) {
        const country = countries.find(
          (country) => country.code === values.delivery_country,
        );
        values.delivery_state = country?.provinces[0].code;
      }

      return { ...prev, ...values };
    });
  };

  useEffect(() => {
    if (customer) {
      setDeliveryAddressFormFields({
        delivery_address: customer.delivery_address,
        delivery_address2: customer.delivery_address2,
        delivery_city: customer.delivery_city,
        delivery_country: customer.delivery_country,
        delivery_state: customer.delivery_state,
        delivery_postcode: customer.delivery_postcode,
        billing_same_as_delivery: areAddressesEqual(customer),
      });
    }
  }, [customer]);

  return {
    deliveryAddressFormFields,
    onUpdateDeliveryAddress,
  };
};

export default useDeliveryAddressForm;
